import { defineBlock, smartProps, ChildrenBlock, useInspectorControl } from '@smartfire/js-block-engine'
import { EditableText } from '@smartfire/components'
import style from './block.module.scss'
import clsx from 'clsx'
import { lazy } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

const Inspector = lazy(() => import('./Inspector'))

function Citation({ invert }) {
    useInspectorControl(Inspector)
    const isMobile = useMediaQuery('(max-width:' + style.mobileBreakpoint + ')')

    const styleLeft = () => {
        if (isMobile) return style.b
        else return invert ? style.b : style.a
    }

    const styleRight = () => {
        if (isMobile) return style.a
        else return invert ? style.a : style.b
    }

    return (
        <div className={style.block}>
            <div className={clsx(style.memo, styleLeft())}>
                <div className={style.top}>
                    <div className={style.line} />
                    <EditableText tagName="h4" smartProp="title" placeholder="Titre" />
                </div>
                <EditableText tagName="p" smartProp="text" placeholder="text" />
                <div className={style.bottom} />
            </div>
            <div className={styleRight()}>
                <ChildrenBlock
                    gutenbergEditorConfig={{
                        allowedBlocks: ['core/heading', 'core/paragraph', 'smartfire/button', 'smartfire/spacer'],
                        template: [['core/heading'], ['core/paragraph'], ['smartfire/button']],
                    }}
                    className={style.blockContact}
                />
            </div>
        </div>
    )
}

export default defineBlock({
    Block: Citation,
    smartProps: {
        text: smartProps.string.withDefault(''),
        title: smartProps.string.withDefault(''),
        invert: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Bloc Memo',
    },
})
